import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Headline } from '@xingternal/typography';

import { FilterResult } from '@/domain/search/helpers';
import { JobSearchFilterCollectionSplitBenefitsFragment } from '@/graphql/generated';

import { WithEntityId } from './types';

import * as S from './filters.styles';

type MultiTagFilterProps = {
  filterTypename: JobSearchFilterCollectionSplitBenefitsFragment['__typename'];
  filter: FilterResult;
  selectedFilters: (JobSearchFilterCollectionSplitBenefitsFragment | null)[];
  onFilterClick: (id: string) => void;
};

const findSelected =
  (option, filterTypename: string | undefined) =>
  (selected: JobSearchFilterCollectionSplitBenefitsFragment | null): boolean =>
    !!selected &&
    selected.__typename === filterTypename &&
    (selected as WithEntityId<JobSearchFilterCollectionSplitBenefitsFragment>).entityId === option.id;

export const MultiTagFilter: React.VFC<MultiTagFilterProps> = ({
  filter,
  filterTypename,
  selectedFilters,
  onFilterClick,
}) => {
  const shouldBeDisplayed = filter.options && filter.options.length > 0;
  const showNewFlag = filter.paramName === 'remoteOption';

  const handleOnFilterClick = (id: string) => (): void => {
    onFilterClick(id);
  };

  return shouldBeDisplayed ? (
    <>
      <S.FiltersContainer>
        <Headline size="medium">
          {showNewFlag ? <S.Flag size="medium" variant="new" /> : null}
          <FormattedMessage id={filter.titleKey} />
        </Headline>
        <S.MultiTagContainer>
          {filter.options?.map((option) =>
            option[filter.paramName] ? (
              <S.SingleTag
                key={option.id}
                selected={selectedFilters.findIndex(findSelected(option, filterTypename)) > -1}
                onClick={handleOnFilterClick(option.id)}
              >
                {option[filter.paramName]?.localizationValue}
              </S.SingleTag>
            ) : null
          )}
        </S.MultiTagContainer>
      </S.FiltersContainer>
      <S.FilterDivider />
    </>
  ) : null;
};
